var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "visit" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticClass: "vTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "row-class-name": "table-row",
            "show-header": false,
            "highlight-current-row": "",
            "tooltip-effect": "dark",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "expand",
              align: "left",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("div", { staticClass: "expand-container" }, [
                      _c(
                        "div",
                        { staticClass: "expand-left" },
                        [
                          _c(
                            "el-form",
                            {
                              staticClass: "table-expand",
                              attrs: { "label-position": "top", inline: "" },
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("visitRecord.table.topics1"),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatVoptions(
                                          props.row.topic1 || ""
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("visitRecord.table.topics2"),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatVoptions(
                                          props.row.topic2 || ""
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("visitRecord.table.topics3"),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatVoptions(
                                          props.row.topic3 || ""
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("visitRecord.table.topics4"),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatVoptions(
                                          props.row.topic4 || ""
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "visitRecord.table.desDetailed1"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(props.row.detail1 || "")),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "visitRecord.table.desDetailed2"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(props.row.detail2 || "")),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "visitRecord.table.desDetailed3"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(props.row.detail3 || "")),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "visitRecord.table.desDetailed4"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(props.row.detail4 || "")),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "line" }),
                          _vm._v(" "),
                          _c(
                            "el-form",
                            {
                              staticClass: "table-expand",
                              attrs: { "label-position": "top", inline: "" },
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "visitRecord.table.followUpMatters1"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(props.row.followUpAction1 || "")
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "visitRecord.table.followUpMatters2"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(props.row.followUpAction2 || "")
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "visitRecord.table.followUpMatters3"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(props.row.followUpAction3 || "")
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "visitRecord.table.followUpDeadline1"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(props.row.followUpDate1 || "")
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "visitRecord.table.followUpDeadline2"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(props.row.followUpDate2 || "")
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "visitRecord.table.followUpDeadline3"
                                    ),
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(props.row.followUpDate3 || "")
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "check-list" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("visitRecord.title.text"))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-form",
                            {
                              staticClass: "table-expand",
                              attrs: { "label-position": "top", inline: "" },
                            },
                            _vm._l(_vm.checkList, function (item, index) {
                              return _c(
                                "el-form-item",
                                { key: index, attrs: { label: item.name } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatN(props.row[item.code] || "")
                                      )
                                    ),
                                  ]),
                                ]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          props.row.isBaiLian
                            ? [
                                _c("div", { staticClass: "check-list" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "storeVisitReport.recordFeedback.subTitle1"
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form",
                                  {
                                    staticClass: "table-expand",
                                    attrs: {
                                      "label-position": "top",
                                      inline: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "storeVisitReport.recordFeedback.acceptTerms"
                                          ),
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              (props.row.recordFeedback || {})[
                                                "acceptTerms"
                                              ] === "Y"
                                                ? _vm.$t("menuList.form.yes")
                                                : _vm.$t("menuList.form.no")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "storeVisitReport.recordFeedback.willingToRtmOrder"
                                          ),
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              (props.row.recordFeedback || {})[
                                                "willingToRtmOrder"
                                              ] === "Y"
                                                ? _vm.$t("menuList.form.yes")
                                                : _vm.$t("menuList.form.no")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "storeVisitReport.recordFeedback.urgentDeliveryTime"
                                          ),
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatterUrgentDeliveryTime(
                                                (props.row.recordFeedback ||
                                                  {})["urgentDeliveryTime"]
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "storeVisitReport.recordFeedback.regularDeliveryTime"
                                          ),
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatterRegularDeliveryTime(
                                                (props.row.recordFeedback ||
                                                  {})["regularDeliveryTime"]
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "check-list" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "storeVisitReport.recordFeedback.subTitle2"
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form",
                                  {
                                    staticClass: "table-expand",
                                    attrs: {
                                      "label-position": "top",
                                      inline: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "storeVisitReport.recordFeedback.evaluateRate"
                                          ),
                                        },
                                      },
                                      [
                                        _c("el-rate", {
                                          attrs: {
                                            max: 10,
                                            colors: [
                                              "#004EA8",
                                              "#004EA8",
                                              "#004EA8",
                                            ],
                                            "show-score": true,
                                            disabled: true,
                                          },
                                          model: {
                                            value: (props.row.recordFeedback ||
                                              {})["evaluateRate"],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                props.row.recordFeedback || {},
                                                "evaluateRate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "(props.row.recordFeedback || {})['evaluateRate']",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form",
                                  {
                                    staticClass: "table-expand",
                                    attrs: {
                                      "label-position": "top",
                                      inline: "",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "storeVisitReport.recordFeedback.goodContent"
                                          ),
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatterGoodContent(
                                                (props.row.recordFeedback ||
                                                  {})["goodContent"] || []
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "storeVisitReport.recordFeedback.badContent"
                                          ),
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatterBadContent(
                                                (props.row.recordFeedback ||
                                                  {})["badContent"] || []
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.$t(
                                            "storeVisitReport.recordFeedback.otherContent"
                                          ),
                                        },
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              (props.row.recordFeedback || {})[
                                                "otherContent"
                                              ] &&
                                                (props.row.recordFeedback ||
                                                  {})["otherContent"].join("；")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "expand-right" }, [
                        props.row.photos && props.row.photos[0]
                          ? _c(
                              "div",
                              { staticClass: "table-previewPhotos" },
                              _vm._l(props.row.photos, function (item, index) {
                                return _c("MyImage", {
                                  key: index,
                                  staticStyle: {
                                    width: "40px",
                                    height: "40px",
                                    border: "1px solid #eee",
                                  },
                                  attrs: {
                                    src: item,
                                    "preview-src-list": props.row.photos,
                                  },
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        props.row.files && props.row.files[0]
                          ? _c("div", { staticClass: "file-icon" }, [
                              _c("img", {
                                attrs: {
                                  width: "40px",
                                  height: "40px",
                                  src: require("../../../../assets/sfe/file-icon.png"),
                                  alt: "",
                                },
                              }),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "left", "show-overflow-tooltip": "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(scope.row.planTaskDateStr || "") +
                          " " +
                          _vm._s(scope.row.planTaskStartTime || "") +
                          "-" +
                          _vm._s(scope.row.planTaskEndTime || "")
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "left", "show-overflow-tooltip": "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _c(
                        "span",
                        {
                          staticStyle: { "font-weight": "600", color: "#444" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("visitRecord.table.visitPurpose1")) +
                              " :"
                          ),
                        ]
                      ),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.formatVoptions(scope.row.visitPurposeOne || "")
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "left", "show-overflow-tooltip": "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _c(
                        "span",
                        {
                          staticStyle: { "font-weight": "600", color: "#444" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("visitRecord.table.visitPurpose2")) +
                              " :"
                          ),
                        ]
                      ),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.formatVoptions(scope.row.visitPurposeTwo || "")
                          ) +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "left", "show-overflow-tooltip": "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _c(
                        "span",
                        {
                          staticStyle: { "font-weight": "600", color: "#444" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("visitRecord.table.participant")) +
                              " :"
                          ),
                        ]
                      ),
                      _vm._v(
                        "\n          " +
                          _vm._s(scope.row.participant || "") +
                          "\n        "
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { align: "left", width: "84" } },
            [[_c("div", [_vm._v(_vm._s(_vm.$t("visitRecord.table.action")))])]],
            2
          ),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { fixed: "right", align: "right", width: "66" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "enote-icon" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/sfe/Store_Details/enote-icon.png"),
                          alt: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openEnote(scope.row.planTaskInfoPk)
                          },
                        },
                      }),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total>0",
          },
        ],
        attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
        on: {
          "update:page": function ($event) {
            _vm.currPage = $event
          },
          "update:limit": function ($event) {
            _vm.limit = $event
          },
          pagination: _vm.fetchData,
        },
      }),
      _vm._v(" "),
      _c("Enote", { ref: "enote" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }